import { render } from "./ShortLinkCreateForm.vue?vue&type=template&id=020a8a21&scoped=true"
import script from "./ShortLinkCreateForm.vue?vue&type=script&lang=js"
export * from "./ShortLinkCreateForm.vue?vue&type=script&lang=js"

import "./ShortLinkCreateForm.vue?vue&type=style&index=0&id=020a8a21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020a8a21"]])

export default __exports__